import { createApi } from '@reduxjs/toolkit/query/react';

import { settings } from '@/_config';

import baseQueryWithReAuth from '../helper/base-query-with-auth';

const answerOnDemandApis = createApi({
  reducerPath: 'answerOnDemandApis',
  baseQuery: baseQueryWithReAuth({ baseUrl: settings.baseURL[1], appName: 'ANSWER_ON_DEMAND', authRequired: true }),
  tagTypes: ['CUSTOMER_NOTES', 'AOD_QUESTIONS', 'AOD_ANSWERS'],
  endpoints: () => ({}),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export default answerOnDemandApis;
